import React from 'react';
import '../css/AboutOverview.css';

const AboutOverview = () => {
  return (
    <section className="gfi-about-gradient-section">
      <div className="gfi-about-overlay-mesh"></div> {/* Sub-pattern overlay for deep premium look */}
      
      <div className="gfi-about-content-container">
        
        {/* Top Tagline with lines exact like image 8 */}
        <div className="gfi-about-tagline-wrapper">
          <span className="gfi-tagline-line"></span>
          <span className="gfi-about-tagline-text">What is special about Greenfield training institute</span>
          <span className="gfi-tagline-line"></span>
        </div>

        {/* Main Section Header */}
        <h2 className="gfi-about-main-heading">
          ABOUT GREENFIELD SAFETY
        </h2>

        {/* Detailed Descriptive Text */}
        <div className="gfi-about-description-body">
          <p>
            Greenfield Industrial Fire and Safety Academy was established with a core vision to bridge the gap between academic education and industrial safety compliance. It has emerged as the premier safety training institute across the region, consistently recognized for its unparalleled commitment to delivering global safety engineering frameworks alongside rigorous academic studies.
          </p>
          <p>
            Till now, Greenfield Safety Institute has successfully shaped the careers of thousands of aspirants, enabling placements in prestigious roles across the country and abroad. The cornerstone of our phenomenal achievement lies in our practical-driven training methodology, state-of-the-art infrastructure, and continuous validation by top global safety bodies. We maintain absolute transparency in our processes, earning absolute trust and unshakeable confidence from our vast network of students and corporate partners alike.
          </p>
        </div>

        {/* Highlighted CTA Button exact like image 8 */}
        <div className="gfi-about-action-area">
          <a href="#about-detail" className="gfi-about-learn-btn">
            Learn More
          </a>
        </div>

      </div>
    </section>
  );
};

export default AboutOverview;